module.exports = __webpack_public_path__ + "static/media/comments.6991aa17.svg";